/**
 * Client-readable cookie set on login and cleared on logout/expiry — see
 * /api/auth/callback. Only a hint: the /api/account response is the truth.
 */
export function hasCustomerAuthHint() {
	if (typeof document === 'undefined') return false;
	return document.cookie.split('; ').includes('customer_auth_hint=1');
}
